import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEntitlement } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

export const Paygate = ({
  entitlement,
  title = "Upgrade to unlock",
  body = "This section is available on a higher plan.",
  children,
  className,
  minHeight = 160,
}) => {
  const allowed = useEntitlement(entitlement);
  if (allowed) return <>{children}</>;
  return (
    <div className={cn("relative", className)} data-testid="paygate-wrapper" style={{ minHeight }}>
      <div className="select-none pointer-events-none filter grayscale blur-[1.5px]" aria-hidden="true">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div
          className="w-full max-w-md border border-border bg-[hsl(var(--card)/0.88)] p-6 text-center shadow-[0_8px_28px_rgba(16,24,40,0.14)] backdrop-blur-md"
          data-testid="paygate-locked-overlay"
        >
          <div className="mx-auto mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-teal-50">
            <Lock className="h-5 w-5 text-primary" />
          </div>
          <h4 className="text-base font-[640] text-foreground">{title}</h4>
          <p className="mt-1 text-sm text-muted-foreground">{body}</p>
          <Link to="/pricing">
            <Button className="mt-4" data-testid="paygate-view-plans-button">View plans</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
